import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { CustomStorageProvider } from '../custom-storage/custom-storage';
import { Constants } from '../../util/Constants';
import { Util } from '../../util/Util';
import { App, ModalController } from 'ionic-angular';

/*
  Generated class for the TutorialProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class TutorialProvider {

  private tutorialList: Object;
  private readAlreadyList: Object;
  private showingTutorial: boolean;

  constructor(public http: Http, public customStorageProvider: CustomStorageProvider, public app: App, public modalCtrl: ModalController) {
    this.tutorialList = {};
    this.readAlreadyList = this.customStorageProvider.get<Object>(Constants.STORAGE_KEY_READ_TUTORIAL_ALREADY);
    if (this.readAlreadyList == null) {
      this.readAlreadyList = {};
      this.save();
    }

    app.viewWillEnter.subscribe(
      (view) => {
        // add 500ms delay to prevent from race condition between the error dialog and the tutorial pop up upon startup
        setTimeout(() => {
          // do not do anything if tutorial is showing already
          if (this.showingTutorial) {
            return;
          }
          let viewName = view.name;
          if (viewName == "GridMenuPage") {
            this.loadTutorialFromServer().then(() => {
              this.checkAndShowTutorial(viewName);
            }).catch(err => {
              console.log(err)
            });
          } else {
            this.checkAndShowTutorial(viewName);
          }
        }, 500);
      }
    )
  }

  checkAndShowTutorial(viewName: string) {
    if (this.shouldShowTutorial(viewName)) {
      let lang = this.customStorageProvider.get<string>(Constants.STORAGE_KEY_LANG);
      if (this.tutorialList[viewName] != null && this.tutorialList[viewName][lang] != null) {
        let images = this.tutorialList[viewName][lang];
        if (images.length > 0) {
          let modal = this.modalCtrl.create("TutorialModalPage", {
            images: images
          }, {
              showBackdrop: true,
              enableBackdropDismiss: false,
              cssClass: "tutorialModal"
            });
          this.showingTutorial = true;
          modal.present();
          modal.onDidDismiss(() => {
            this.showingTutorial = false;
            this.setTutorialAsRead(viewName);
          })
        }
      }
    }
  }

  loadTutorialFromServer(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      let lang = this.customStorageProvider.get<string>(Constants.STORAGE_KEY_LANG);
      this.http.get(Util.getTutorialListUrl()).toPromise().then(data => {

        if (data != null && data.json() != null) {
          this.tutorialList = data.json().tutorial;

          for (let obj in this.tutorialList) {
            if (this.readAlreadyList[obj] != null && this.readAlreadyList[obj][lang] != null) {
              if (JSON.stringify(this.readAlreadyList[obj][lang].content) != JSON.stringify(this.tutorialList[obj][lang])) {
                this.readAlreadyList[obj][lang].content = null;
                this.readAlreadyList[obj][lang].readAlready = false;
              }
            }
          }
          resolve();
        }
      }).catch(err => {
        console.log(err)
        reject();
      });
    })
  }

  shouldShowTutorial(pageName?: string) {
    let activeNav = null;
    if (this.app.getActiveNavs() != null && this.app.getActiveNavs().length > 0) {
      activeNav = this.app.getActiveNavs()[0];
    }
    let nav = this.app._appRoot._getActivePortal() || activeNav;

    let activeView = nav.getActive();

    if (activeView != null) {
      if(activeView.isOverlay) {
        return false;
      }
    }

    let lang = this.customStorageProvider.get<string>(Constants.STORAGE_KEY_LANG);
    if (pageName == null && this.app.getActiveNavs() != null && this.app.getActiveNavs().length > 0) {
      pageName = this.app.getActiveNavs()[0].name;
    }

    if (this.tutorialList == null || this.tutorialList[pageName] == null) {
      return false;
    }

    // this.readAlreadyList = this.customStorageProvider.get<Object>(Constants.STORAGE_KEY_READ_TUTORIAL_ALREADY);
    return this.readAlreadyList[pageName] == null || this.readAlreadyList[pageName][lang] == null || this.readAlreadyList[pageName][lang].readAlready == false;
  }

  setTutorialAsRead(pageName?: string) {
    let lang = this.customStorageProvider.get<string>(Constants.STORAGE_KEY_LANG);
    if (pageName == null && this.app.getActiveNavs() != null && this.app.getActiveNavs().length > 0) {
      pageName = this.app.getActiveNavs()[0].name;
    }
    // this.readAlreadyList = this.customStorageProvider.get<Object>(Constants.STORAGE_KEY_READ_TUTORIAL_ALREADY);
    if (this.readAlreadyList[pageName] == null) {
      this.readAlreadyList[pageName] = {};
    }
    if (this.readAlreadyList[pageName][lang] == null) {
      this.readAlreadyList[pageName][lang] = {};
    }
    this.readAlreadyList[pageName][lang].readAlready = true;
    this.readAlreadyList[pageName][lang].content = this.tutorialList[pageName][lang];
    this.save();
  }

  setTutorialAsUnread(pageName?: string) {
    let lang = this.customStorageProvider.get<string>(Constants.STORAGE_KEY_LANG);
    if (pageName == null && this.app.getActiveNavs() != null && this.app.getActiveNavs().length > 0) {
      pageName = this.app.getActiveNavs()[0].name;
    }
    if (this.readAlreadyList[pageName] == null) {
      this.readAlreadyList[pageName] = {};
    }
    if (this.readAlreadyList[pageName][lang] == null) {
      this.readAlreadyList[pageName][lang] = {};
    }
    // this.readAlreadyList = this.customStorageProvider.get<Object>(Constants.STORAGE_KEY_READ_TUTORIAL_ALREADY);
    this.readAlreadyList[pageName][lang].readAlready = false;
    this.readAlreadyList[pageName][lang].content = null;
    this.save();
  }

  save() {
    this.customStorageProvider.set(Constants.STORAGE_KEY_READ_TUTORIAL_ALREADY, this.readAlreadyList);
  }

  resetAll() {
    this.customStorageProvider.remove(Constants.STORAGE_KEY_READ_TUTORIAL_ALREADY);
    this.readAlreadyList = {};
  }
}



// WEBPACK FOOTER //
// ./src/providers/tutorial/tutorial.ts